"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFormFieldByConfig = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.camelcase"));
var _lodash2 = _interopRequireDefault(require("lodash.split"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _components = require("../components");
var _utils = require("../utils");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const handleChangeAllowOnlyNumber = (value, available) => available ? value.replaceAll(/\D/g, '') : value;
const TextFormFieldByConfig = props => {
  const {
    name,
    label,
    helperText,
    isEditable,
    isAvailable,
    displayOrder,
    isMandatory,
    initialValue,
    isAddressMatchRequired,
    keyboardType,
    inputType,
    customPlaceholder,
    enableLowercaseLetters,
    useUpperCase,
    allowOnlyNumbers,
    customErrors,
    variant,
    customerLoginUrl,
    rows,
    isMultiline,
    isDisabled,
    autoFocus,
    maxLengthLimit,
    customMaxWidth
  } = props;
  const {
    setFocus,
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const submitError = customErrors?.find(error => error.fieldName?.toLowerCase() === name.toLowerCase());
  const formatError = (0, _lodash2.default)(submitError?.fieldName, '.').map(item => (0, _lodash.default)(item));
  const joinFormatError = formatError.join('.');
  (0, _react.useEffect)(() => {
    if (submitError) {
      setFocus(joinFormatError);
    }
  }, [customErrors, joinFormatError, setFocus, submitError]);
  const errorMessage = submitError ? (0, _utils.getErrorLocalizationByCode)(submitError?.errorCode, name) : undefined;
  const readOnly = isAddressMatchRequired ?? false;
  const fieldPlaceholder = customPlaceholder;
  const capitalize = enableLowercaseLetters ? 'off' : 'on';
  const readOnlyStyleBox = {
    display: 'flex',
    height: '0',
    alignItems: 'center',
    justifyContent: 'center'
  };
  const handleTrimValue = fieldValue => {
    const correctValue = useUpperCase ? fieldValue?.toLocaleUpperCase() : fieldValue;
    setValue(name, correctValue?.trim(), {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    });
  };
  const partOfAddress = name.includes('address') ? 10 : 1;
  // we need start tabindex from 1 but displayOrder starts from 0
  const correctTabIndex = typeof displayOrder === 'number' ? displayOrder + partOfAddress : displayOrder;
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      margin: readOnly ? '0' : '0 auto 20px',
      maxWidth: customMaxWidth ?? 500,
      style: readOnly ? readOnlyStyleBox : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        defaultValue: initialValue,
        render: ({
          field: {
            ref,
            onChange,
            ...field
          },
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
          fullWidth: true,
          children: [readOnly ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
            fullWidth: true,
            type: inputType ?? 'text',
            label: label,
            multiline: isMultiline,
            placeholder: fieldPlaceholder,
            variant: variant ?? 'outlined',
            error: !!fieldState.error || Boolean(submitError),
            helperText: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...getTestIdProps(`${name}-text-field-error-message`),
              children: fieldState.error.message
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: submitError ? null : helperText
            }),
            disabled: isDisabled ?? !isEditable,
            required: isMandatory,
            defaultValue: field.value,
            inputProps: {
              tabIndex: correctTabIndex,
              maxLength: maxLengthLimit,
              inputMode: keyboardType ?? 'text',
              autoFocus,
              'data-testid': getTestId(`${name}-text-field`),
              autoCapitalize: capitalize,
              style: {
                textTransform: useUpperCase ? 'uppercase' : 'initial'
              },
              sx: {
                '&::placeholder': {
                  textTransform: 'initial'
                }
              }
            }
            // eslint-disable-next-line react/jsx-no-duplicate-props --- we needed is not duplicate props
            ,
            InputProps: {
              endAdornment: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
                color: "error"
              }) : null,
              autoComplete: 'off',
              rows,
              autoFocus
            },
            ...field,
            value: field.value || '',
            inputRef: ref,
            onBlur: () => handleTrimValue(field.value),
            onChange: e => onChange(handleChangeAllowOnlyNumber(e.target.value, allowOnlyNumbers))
          }), errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ErrorMessage, {
            errorMessage: errorMessage,
            customerLoginUrl: customerLoginUrl
          }) : null]
        })
      })
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.TextFormFieldByConfig = TextFormFieldByConfig;
